export const checklistConstants = {
  REGISTER_REQUEST: 'CHECKLIST_REGISTER_REQUEST',
  REGISTER_SUCCESS: 'CHECKLIST_REGISTER_SUCCESS',
  REGISTER_FAILURE: 'CHECKLIST_REGISTER_FAILURE',

  GET_REQUEST: 'CHECKLIST_REQUEST',
  GET_SUCCESS: 'CHECKLIST_SUCCESS',
  GET_FAILURE: 'CHECKLIST_FAILURE',

  GETALL_REQUEST: 'CHECKLIST_GETALL_REQUEST',
  GETALL_SUCCESS: 'CHECKLIST_GETALL_SUCCESS',
  GETALL_FAILURE: 'CHECKLIST_GETALL_FAILURE',

  DELETE_REQUEST: 'CHECKLIST_DELETE_REQUEST',
  DELETE_SUCCESS: 'CHECKLIST_DELETE_SUCCESS',
  DELETE_FAILURE: 'CHECKLIST_DELETE_FAILURE',
};